import * as _ from "lodash";

function memoizeDebounceFunction(func: () => unknown, timeout: number, leading?: boolean, trailing?: boolean) {
    return _.memoize(function () {
        return _.debounce(func, timeout, { leading, trailing })
    });
}

export default function MemoizeDebounce(timeout: number, leading?: boolean, trailing?: boolean): MethodDecorator {

    return function (target: object, key: string | symbol, descriptor: PropertyDescriptor | undefined) {

        if (descriptor === undefined) {
            descriptor = Object.getOwnPropertyDescriptor(target, key);
        }
        if (descriptor === undefined) {
            throw new Error(`target has no descriptor for key "${String(key)}"`)
        }

        const originalMethod = descriptor.value;

        const memoized = memoizeDebounceFunction(originalMethod, timeout, leading, trailing);

        descriptor.value = function (...args: []) {
            memoized.apply(target, args).apply(target, args);
        };
    }
}